import React from 'react';
import { createPortal } from 'react-dom';
import { backdropCloseHandlers } from '../../../../utils/backdropClose';
import './LeaveProjectModal.css';

const LeaveProjectModal = ({
  isOpen,
  projectName = '',
  isSubmitting = false,
  onCancel,
  onConfirm
}) => {
  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }
    onCancel?.();
  };

  const modalMarkup = (
    <div
      className="leave-project-modal-overlay"
      {...backdropCloseHandlers(handleClose)}
      role="dialog"
      aria-modal="true"
      aria-label="Leave project"
    >
      <div
        className="leave-project-modal-content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="leave-project-modal-header">
          <div className="leave-project-modal-header-left">
            <div className="leave-project-modal-icon-wrap">
              <i className="fa-solid fa-right-from-bracket leave-project-modal-header-icon" aria-hidden="true" />
            </div>
            <h3>Leave Project</h3>
          </div>
          <button
            type="button"
            className="leave-project-modal-close"
            onClick={handleClose}
            disabled={isSubmitting}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className="leave-project-modal-body">
          <p className="leave-project-modal-message">
            You are about to leave <strong>{projectName || 'this project'}</strong>.
          </p>
          <p className="leave-project-modal-warning">
            <i className="fa-solid fa-triangle-exclamation leave-project-modal-warning-icon" aria-hidden="true" />
            You will immediately lose access to this project and all its data.
          </p>
        </div>

        <div className="leave-project-modal-actions">
          <button
            type="button"
            className="leave-project-modal-btn leave-project-modal-btn-cancel"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`leave-project-modal-btn leave-project-modal-btn-confirm${isSubmitting ? ' is-leaving' : ''}`}
            onClick={onConfirm}
            disabled={isSubmitting}
            aria-busy={isSubmitting ? 'true' : 'false'}
          >
            {isSubmitting ? 'Leaving...' : 'Leave Project'}
          </button>
        </div>
      </div>
    </div>
  );

  return typeof document !== 'undefined'
    ? createPortal(modalMarkup, document.body)
    : modalMarkup;
};

export default LeaveProjectModal;
